import { Box, CircularProgress, Typography } from '@mui/material';
import { useLocalization } from '@assetron/common/hooks/useLocalization';
import React from 'react';
import LogoMain from '../../logo/LogoMain';
import { usePlansStyles } from './styles/usePlansStyles';
import { useSetupSuccessStyles } from './styles/useSetupSuccessStyles';
import PlansLayout from '../pages/plans/PlansLayout';
import CreditCardRefreshIcon from '../../../icons/CreditCardRefresh';
import FeaturedIcon from '../FeaturedIcon/FeaturedIcon';

function FinalizeSubsciptionLoading() {
  const styles = useSetupSuccessStyles();
  const planStyles = usePlansStyles();
  const { t } = useLocalization();
  const getInitializationComponent = () => (
    <Box sx={planStyles.errorTitleContainer}>
      <FeaturedIcon
        size="xl"
        variant="Error"
        icon={<CreditCardRefreshIcon />}
      />
      <Typography variant="large_heading_30_semibold">
        {t('setup.initializing.title')}
      </Typography>
    </Box>
  );

  const getInitializationSubtitleComponent = () => (
    <Box sx={planStyles.errorSubtitleContainer}>
      <Typography variant="body_14_regular" component="div">
        {t('setup.initializing.subtitle')}
      </Typography>
    </Box>
  );

  const initializeSubscriptionContent = (
    <PlansLayout
      title={getInitializationComponent}
      subtitle={getInitializationSubtitleComponent}
      titleSpacing="lg"
    >
      <Box sx={planStyles.errorContentContainer}>
        <Box sx={planStyles.button}>
          <Box sx={styles.inlineLoader}>
            <CircularProgress color="secondary" size={24} />
          </Box>
        </Box>
        <Box sx={styles.supportContainer}>
          <Box sx={styles.supportInline}>
            <Typography
              variant="body_14_regular"
              component="span"
              sx={styles.supportText}
            >
              {t('setup.initializing.underLoader')}
            </Typography>
          </Box>
        </Box>
      </Box>
    </PlansLayout>
  );

  return (
    <>
      <Box sx={styles.logoContainer}>
        <Box sx={styles.headerContainer}>
          <LogoMain showCursor={false} />
        </Box>
      </Box>
      <Box sx={styles.mainContainer}>{initializeSubscriptionContent}</Box>
    </>
  );
}

export default FinalizeSubsciptionLoading;
